<template>
  <b-card no-body>
    <b-card-header>密码设置</b-card-header>
    <b-card-body>
      <b-form-group label="旧密码">
        <b-form-input v-model="g_config.admin_password_old" type="password"></b-form-input>
      </b-form-group>
      <b-form-group label="新账户名">
        <b-form-input v-model="g_config.admin_username"></b-form-input>
      </b-form-group>
      <b-form-group label="新密码">
        <b-form-input v-model="g_config.admin_password" type="password"></b-form-input>
      </b-form-group>
      <b-form-group label="重复新密码">
        <b-form-input v-model="g_config.admin_password1" type="password"></b-form-input>
      </b-form-group>
      <b-button
        href="#"
        variant="primary"
        :disabled="waiting"
        style="min-width: 80px;"
        @click="save"
      >{{waiting?"提交中":"保存"}}</b-button>
    </b-card-body>
  </b-card>
</template>
<script>
export default {
  data() {
    return {
      waiting: false,
      g_config: {
        admin_password_old: "",
        admin_username: "",
        admin_password: "",
        admin_password1: ""
      }
    };
  },
  methods: {
    save() {
      let _this = this;
      if (_this.g_config.admin_password !== _this.g_config.admin_password1) {
        return _this.$message("两次密码不一致", "w");
      }
      if (!_this.g_config.admin_username || !_this.g_config.admin_password) {
        return _this.$message("用户名或密码为空", "w");
      }

      this.waiting = true;
      this.common.axios
        .post("./admin/ajax/save", {
          G_CONFIG: {
            admin_username: _this.g_config.admin_username,
            admin_password: _this.g_config.admin_password,
            admin_password_old: _this.g_config.admin_password_old
          }
        })
        .then(r => {
          _this.waiting = false;
          this.common.axios.get("./admin/public/logout").catch(() => {});
          alert(r.data.info);
          this.$store.commit("logoutSuccess");
          this.$router.push({ path: "/login" });
        })
        .catch(e => {
          _this.waiting = false;
          console.log(e);
          _this.$message(
            e.response && e.response.data.info
              ? e.response.data.info
              : e.message,
            "d"
          );
        });
    }
  }
};
</script>